import { BodyMEmphasis, type ComponentWrapperType } from "@cerebruminc/cerebellum";
import { useAtomValue } from "jotai";
import React, { type FC } from "react";

import { useMeQuery } from "src/generated/graphql";
import { viewerHasCraAffiliates } from "src/helpers/userPermissions";
import { currentOrgIdAtom } from "src/shame/shame-atoms";

import { visibleRoleLabels } from "../helpers";

export const RoleCell: FC<ComponentWrapperType> = ({ row }) => {
	const currentOrgId = useAtomValue(currentOrgIdAtom);
	const { data: loggedInUserData } = useMeQuery();
	const viewerRoles = loggedInUserData?.me?.roleAssignment?.map((assignment) => assignment.roleV2.name);
	const viewerBelongsToCra = viewerHasCraAffiliates(loggedInUserData?.me?.organizations);
	const allOrgsMode = currentOrgId === null;
	let name = "";

	if (allOrgsMode) {
		if ((row?._count?.organizations ?? 0) > 1) {
			return <BodyMEmphasis data-sentry-unmask>Multiple roles</BodyMEmphasis>;
		}
		const allRoleNames = row?.roleAssignment?.map((item: { roleV2?: { name?: string } }) => item.roleV2?.name) ?? [];
		name = visibleRoleLabels({ roleNames: allRoleNames, viewerBelongsToCra, viewerRoles }).join(", ");
	} else {
		const match = row?.roleAssignment?.find(
			(item: { organizationId?: string; roleV2?: { name?: string } }) => item.organizationId === currentOrgId,
		);
		name = visibleRoleLabels({ roleNames: [match?.roleV2?.name], viewerBelongsToCra, viewerRoles }).join(", ");
	}

	return <BodyMEmphasis data-sentry-unmask>{name}</BodyMEmphasis>;
};
